import { authActions } from './actions';
import { authMutations } from './mutations';
import { authGetters } from './getters';

const state = {
  authenticated: !!localStorage.getItem('access_token'),
  accessToken: localStorage.getItem('access_token'),
  idToken: localStorage.getItem('id_token'),
  expiresAt: localStorage.getItem('expires_at'),
  role: localStorage.getItem('role'),
  name: localStorage.getItem('name'),
  picture: localStorage.getItem('picture'),
  loginError: false,
};
const actions = { ...authActions };
const mutations = { ...authMutations };
const getters = { ...authGetters };


// eslint-disable-next-line import/prefer-default-export
export const authStore = {
  state, actions, mutations, getters,
};
